module.exports = function () {
  var html = "\n      <div class=\"war-overlay\" id=\"war-overlay\">\n        <div class=\"status\"></div>\n        <div class=\"controls\"></div>\n\t<div class=\"warquote\">\n\t  Grim-visaged war has mounted barded steeds /\n\t  To fright the souls of fearful adversaries\n\t</div>\n      </div>\n  ";
  return html;
};